import "../i18nFallback";
import "../sentryInstrumentReact";
import React from 'react';

export function getCartItemDisplayTitle(item) {
  const title = item?.productDetails?.title || "";
  const attributes = item?.variantDetails?.attributes;
  const hasAttributes = attributes && Object.values(attributes).some(Boolean);
  return hasAttributes
    ? `${title} - ${Object.values(attributes).join(" - ")}`
    : title;
}

function UndoRemovalBanner({ itemTitle, onUndo, durationMs }) {
  return (
    <div className="undo-removal-banner" role="status" aria-live="polite">
      <div className="undo-removal-banner__content">
        <span>
          {window.interpolate(window.gettext("Removed %s."), [itemTitle])}
        </span>
        <button
          type="button"
          className="undo-removal-banner__undo"
          onClick={onUndo}
        >
          {window.gettext("Undo")}
        </button>
      </div>
      <div className="undo-removal-banner__progress" aria-hidden="true">
        <div
          className="undo-removal-banner__progress-bar"
          style={{ animationDuration: `${durationMs}ms` }}
        />
      </div>
    </div>
  );
}

export default UndoRemovalBanner;
